import axios from 'axios'
import { API_URL } from '../../../../setup/config/env'

export function createOrUpdatebookingSetting(bookingSetting) {
    return dispatch => {
      return axios.post(API_URL+"/api/tableBookingConfig/createOrUpdate", { ...bookingSetting })
    }
}

export function cancelBooking(bookingId, reason) {
  return dispatch => {
    return axios.post(API_URL+"/api/tableBooking/cancel-booking", { "_id": bookingId, reason })
  }
}

export function bookTable ({ name, email, phoneNumber, persons, timeSlot, occasion, assignedTables }) {
  return dispatch =>{
    return axios.post(API_URL+"/api/tableBooking/bookTable", { name, email, phoneNumber, persons, timeSlot, occasion, assignedTables })
  }
};

export function deleteBooking({ bookingIds }) {
  return dispatch => {
    return Promise.all(
      bookingIds.map(bookingId =>
        axios.post(API_URL + "/api/tableBooking/delete", { "bookingIds": [ bookingId ] })
      )
    ).then(responses => {
      return responses.map(response => response.data);
    });
  };
}